import {
	ContainerGutter,
	TokenTextAppearance,
	TokenTextColor,
	TextAlignment,
	Container,
	Text,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { huchaLinesColor } from '../../../../../../helpers/color-tokens';

const MainContainer = styled(Container)`
	padding: 0px;
	display: none;

	/* Desktop */
	@media (min-width: 1600px) {
		display: block;
		padding-left: var(--size-dynamic0100);
		padding-right: var(--size-dynamic0100);
	}
`;

const StyledC2Wrapper = styled(Container)`
	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	align-content: center;
	padding-left: 4px;
	padding-right: 4px;

	margin-left: auto;
	margin-right: auto;

	/* padding top and bottom depends on the fixed height */

	/* Desktop */
	@media (min-width: 1600px) {
		height: 193px;
	}
`;

export const HuchaStandardCardC2 = () => {
	return (
		<MainContainer stretchContent data-testid="c2-container">
			<StyledC2Wrapper
				data-testid="c2-inner-container"
				stretchContent
				wrap="always"
				verticalAlign="center"
				horizontalAlign="center"
				gutter={ContainerGutter.dynamic0020}
			>
				<Text
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.left}
				>
					Cada mes, acumulas 10€ para tu próximo Volkswagen.
				</Text>
			</StyledC2Wrapper>
		</MainContainer>
	);
};
